import assign from 'lodash/assign'
import isEmpty from 'lodash/isEmpty'
import merge from 'lodash/merge'
import search from 'pinyin/search'
import highlight from 'pinyin/highlight'

import ImgPopupDirective from 'components/common/img-pop/directive'
import SelectFile from 'components/common/SelectFile.vue'

import fileicon from 'utils/fileicon'
import filesize from 'utils/filesize'
import * as regexp from 'utils/regexp'
import selectFile from 'utils/selectFile'
import sub from 'utils/sub'

import Message from 'common/message'
import { msgbox, alert, confirm, dangerConfirm, prompt } from 'common/messageBox'
import { handleError } from 'common/error'
import guard from 'common/loadingGuard'
import * as rules from 'common/rules'

const install = function (Vue) {
  /* istanbul ignore if */
  if (install.installed) return
  /* istanbul ignore next */
  Vue.prototype.$app_name = process.env.VUE_APP_NAME || '未来校园'
  // 修改 element ui 的提示
  Vue.prototype.$message = Message
  // 弹框
  Vue.prototype.$msgbox = msgbox
  Vue.prototype.$alert = alert
  Vue.prototype.$confirm = confirm
  Vue.prototype.$dangerConfirm = dangerConfirm
  Vue.prototype.$prompt = prompt
  // 拼音搜索
  Vue.prototype.$search = search
  // 高亮
  Vue.prototype.$highlight = highlight
  // 减少 ajax 请求的重复性代码
  Vue.prototype.$guard = guard
  // 处理异常，可以显示出合理的错误信息
  Vue.prototype.$handleError = handleError
  // 将 form.validate form.validateField 转成 Promise 的形式
  /* istanbul ignore next */
  Vue.prototype.$validate = function (form, prop) {
    if (prop) return new Promise(resolve => form.validateField(prop, resolve))
    return new Promise(resolve => form.validate(resolve))
  }
  // form rules
  Vue.prototype.$rules = rules
  Vue.prototype.$isEmpty = isEmpty
  Vue.prototype.$merge = merge
  Vue.prototype.$assign = assign
  // 可以组合 url 上的请求参数
  /* istanbul ignore next */
  Vue.prototype.$mergeQuery = function (query) {
    return assign({}, this.$query, query)
  }
  /* istanbul ignore next */
  Object.defineProperty(Vue.prototype, '$query', {
    get () {
      return this.$route.query
    },
  })
  /* istanbul ignore next */
  Vue.prototype.$updateQuery = function (newQuery) {
    Vue.prototype.$dontReload = true
    this.$router.replace({query: this.$mergeQuery(newQuery)})
    setTimeout(() => Vue.prototype.$dontReload = false, 0)
  }
  Vue.prototype.$isImage = url => regexp.image_type().test(url)
  // 选文件的函数（不能支持 Promise）
  Vue.prototype.$selectFile = selectFile
  Vue.component(SelectFile.name, SelectFile)
  // 班级名称
  let getGroupName = name => name + (name.includes('班') ? '' : '班')
  Vue.prototype.$groupName = getGroupName
  Vue.filter('groupName', getGroupName)
  Vue.filter('sub', sub)
  Vue.filter('filesize', filesize)
  Vue.filter('fileicon', fileicon)
  Vue.directive(ImgPopupDirective.name, ImgPopupDirective)
}

export default {install}



// WEBPACK FOOTER //
// ./src/plugin.js